<template>
  <div class="bg-white rounded p-2">
    <nav class="custom-tab-menu w-100 text-center">
      <div :class="{ active: activeTab == 0 }" @click="activeTab = 0">{{ $t("file-manager.files") }}</div>
      <div :class="{ active: activeTab == 1 }" @click="activeTab = 1">{{ $t("file-manager.pending-approval-2") }}</div>
    </nav>
    <div class="mt-4">
      <div v-if="activeTab == 0">
        <file-manager scope="BGYS"></file-manager>
      </div>
      <div v-if="activeTab == 1">
        <OrganizationFilePendingApproval></OrganizationFilePendingApproval>
      </div>
    </div>
  </div>
</template>

<script>
import FileAccessingMembersForm from "./file-accessing-members-form.vue";
import FileCategoryForm from "./file-category-form.vue";
import FileHistory from "./file-history.vue";
import FileManager from "./file-manager";
import FileUpload from "./file-upload.vue";
import InventoryDiff from "./inventory-diff.vue";
import OrganizationFilePendingApproval from "./organization-file-pending-approval";

export default {
  props: ["scope"],
  components: {
    FileCategoryForm,
    FileUpload,
    FileAccessingMembersForm,
    FileHistory,
    InventoryDiff,
    OrganizationFilePendingApproval,
    FileManager,
  },

  watch: {},
  computed: {
    activeTab: {
      get() {
        return this.$store.getters["fileManager/selectedTab"];
      },
      set(v) {
        this.$store.commit("fileManager/selectedTab", v);
      },
    },
  },
};
</script>
<style scoped>
.category-item .trash-icon {
  visibility: hidden; /* Varsayılan olarak gizle */
}

.category-item:hover .trash-icon {
  visibility: visible; /* Hover durumunda göster */
}
.custom-tab-menu {
  display: flex;
  justify-content: center;
  align-items: center;
  /* border-bottom: 1px solid #d6d7df; */
  background-color: #fff;
  width: max-content;

  div {
    padding: 0.62rem 2rem;
    color: #071437;
    font-size: 1.125rem;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    border-bottom: 2px solid transparent;
    cursor: pointer;

    &:hover,
    &.active {
      color: #ff7c48;
      background-color: transparent;
      border-color: #ff7c48;
    }
  }
}
</style>
